import { render } from "./ConfirmationAlert.vue?vue&type=template&id=ca1c44f2&scoped=true"
import script from "./ConfirmationAlert.vue?vue&type=script&lang=js"
export * from "./ConfirmationAlert.vue?vue&type=script&lang=js"

import "./ConfirmationAlert.vue?vue&type=style&index=0&id=ca1c44f2&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1c44f2"]])

export default __exports__